import { useCloudCameras } from '../hooks/useCloudCameras'

import { Box } from '@hivewatch/dark'

import { useAppSelector } from '@/redux/hooks'
import { selectVideoWallCells } from '@/redux/videoWall/videoWallSlice'

import {
  VIDEO_WALL_COLS,
  VIDEO_WALL_ROWS,
  VIDEO_WALL_Z_INDEX,
} from '../constants/constants'
import { VideoWallCell } from './VideoWallCell'

/**
 * The full-screen video wall content: the fixed 2x3 grid of camera cells filling
 * the viewport. Rendered only while the wall is open (see VideoWallOverlay), and
 * always inside a <DarkProvider>. The wall is dismissed via the "W" / Escape
 * shortcut (see useVideoWallShortcut) — there is no on-screen chrome.
 */
export const VideoWall = () => {
  const cells = useAppSelector(selectVideoWallCells)
  const { cameras, isLoading, isError, refetch } = useCloudCameras()

  return (
    <Box
      bg='bg.app'
      bottom={0}
      data-testid='video_wall_overlay'
      display='grid'
      gap='12px'
      gridTemplateColumns={`repeat(${VIDEO_WALL_COLS}, 1fr)`}
      gridTemplateRows={`repeat(${VIDEO_WALL_ROWS}, 1fr)`}
      left={0}
      p='24px'
      position='fixed'
      right={0}
      top={0}
      zIndex={VIDEO_WALL_Z_INDEX}
    >
      {cells.map((cell, index) => (
        <VideoWallCell
          availableCameras={cameras}
          camerasLoading={isLoading}
          cell={cell}
          hasCamerasError={isError}
          index={index}
          key={`video-wall-cell-${index}`}
          onRetryCameras={refetch}
        />
      ))}
    </Box>
  )
}
